import { TDatabaseId } from '@infotech-soe/metaschema';
import React from 'react';

import { WorkTableType } from '../../../services/commands/UserInteractor';
import { WorkTableState } from '../../../store/slices/workTable';

import WorkTableForm from './form/WorkTableForm';

interface Props {
  workerId: TDatabaseId;
  table: WorkTableState;
}

const WorkTable = ({ workerId, table }: Props): React.JSX.Element => {
  const row = table.context.get('Row');
  if (table.tableType === WorkTableType.CALENDAR) {
    return (
      <WorkTableForm
        tableId={workerId}
        data={table.data}
        month={table.data.startDate.getMonth()}
        year={table.data.startDate.getFullYear()}
        scheduleCode={row.SSCHEDULE}
      />
    );
  } else if (table.tableType === WorkTableType.TIME_BOARD) {
    return (
      <WorkTableForm
        hasContextMenu={false}
        tableId={workerId}
        data={table.data}
        month={table.data.startDate.getMonth()}
        year={table.data.startDate.getFullYear()}
        fullName={row.SCLNPSPFM_FULLNAME}
        tellerNumber={`${row.STAB_PREF.trim()}-${row.STAB_NUMB.trim()}`}
      />
    );
  } else {
    return (
      <WorkTableForm
        tableId={workerId}
        data={table.data}
        month={table.data.startDate.getMonth()}
        year={table.data.startDate.getFullYear()}
        scheduleCode={table.data.postPerform.scheduleCode}
        fullName={row.SFULLNAME}
        tellerNumber={`${row.SPERS_TAB_PREF.trim()}-${row.SPERS_TAB_NUMB.trim()}`}
      />
    );
  }
};

export default WorkTable;
